export function getAudioTypeFromDataURL(dataURL: string): string {
  const regex = /^data:audio\/([a-zA-Z0-9]+);base64/;
  const match = dataURL.match(regex);

  if (!match) {
    throw new Error('Invalid data URL or not an audio file.');
  }

  const audioType = match[1];

  const validAudioTypes = ['mp3', 'wav', 'ogg', 'flac', 'aac', 'm4a', 'webm'];

  if (!validAudioTypes.includes(audioType)) {
    throw new Error(`Unsupported audio type: ${audioType}`);
  }

  return audioType;
}
